import React, { memo } from 'react';
import { DEMO_USER_PICTURE, placeDemoUserPicture } from '../../../../common/common';
import useRedirect from '../../../../components/customHooks/useRedirect';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import './css/doctorCard.scss';
const DoctorCard = ({ data, docCardClick, gtmTagVariable = '' }) => {
  const { sessions_doctors_id, profile_image, profile, doctor_name, subtitle } = data;
  const { redirectTo } = useRedirect();
  return (
    <div
      className={`w-100 text-start rounded connectCard d-flex align-items-center justify-content-between cursorPointer bg-white shadow position-relative py-3 ps-3 pe-5 gtm_cl_doctorCard`}
      onClick={() =>
        sessions_doctors_id &&
        redirectTo('SpeakerProfile', sessions_doctors_id, doctor_name, 'active=true')
      }
    >
      {profile_image && (
        <div
          className={`rounded-circle connectCardPic position-relative overflow-hidden gtm_cl_doctorCard`}
        >
          <LazyImage
            src={profile_image}
            className={`object-fit-cover w-100 h-100 float-start gtm_cl_doctorCard`}
            fallback_image={DEMO_USER_PICTURE}
            alt={doctor_name}
            logo
          />
        </div>
      )}
      <div className={`connectCardContent ps-3 pe-2 gtm_cl_doctorCard`}>
        {doctor_name && (
          <h2 className={`text-black fs-4 fw-medium line-clamp-1 gtm_cl_doctorCard`}>
            {doctor_name}
            {/* {doctor_name?.length > 50 ? doctor_name?.substring(0, 50) + '...' : doctor_name} */}
          </h2>
        )}
        {profile && (
          <p className={`text-dark fs-5 mb-1 gtm_cl_doctorCard`}>
            {profile?.length > 55 ? profile.substring(0, 55) + '...' : profile}
          </p>
        )}
        {/* {subtitle && <h4 className="text-dark fs-5">{subtitle}</h4>} */}
      </div>
      <span
        className={`text-primary connectCardIcon position-absolute top-50 translate-middle-y d-inline-block gtm_cl_doctorCard`}
      >
        <i className="flaticon-add-contact fs-1 gtm_cl_doctorCard"></i>
        {/* <svg strokeWidth="0" viewBox="0 0 24 24" className={`fs-2 gtm_cl_doctorCard`}>
          <g>
            <path className={`gtm_cl_doctorCard`} fill="none" d="M0 0h24v24H0z"></path>
            <path
              className={`gtm_cl_doctorCard`}
              d="M14 14.252V22H4a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm6 4v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
            ></path>
          </g>
        </svg> */}
      </span>
    </div>
  );
};
export default memo(DoctorCard);
